export default __webpack_public_path__ + "static/media/logoColorXXS.75efc21e.webp";